export default __webpack_public_path__ + "static/media/1_Gletscherspalte.14f50f0b.png";